module.exports = __webpack_public_path__ + "static/media/title-look.1a4112e4.png";